<template>
  <div class="d-flex justify-content-end">
    <McTableFilter
      :activeFilters="activeFilters"
      :parseFilterDataMappings="parseFilterDataMappings"
      @submit="handleInput"
      :isSearchWithFilter="searchWithFilter"
    >
      <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
        <!-- <div class="mc-modal__filter-item">
          <FormulateInput
            name="licensePlate"
            :label="$t('global.object.licensePlate')"
            :placeholder="`${$t('global.form.select')} ${$t('global.object.licensePlate')}`"
            :multiple="true"
            type="value-help-v2"
            trackBy="licensePlate"
            :displayedBy="'licensePlate'"
            :listGetter="resourcefulQuery.vehicle"
            :tableFields="vehicleTableFields"
            :fullObject="fullObjects['licensePlate']"
            @update:formValues="updateFormValues({ key: 'licensePlate', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'licensePlate', value: $event })"
            :value="formValues.licensePlate"
          >
          </FormulateInput>
        </div> -->
        <div class="mc-modal__filter-item">
          <FormulateInput
            name="fleetType"
            :label="$t('global.field.vehicleType')"
            :placeholder="`${$t('global.form.select')} ${$t('global.field.vehicleType')}`"
            :multiple="true"
            type="value-help-v2"
            trackBy="vehicleTypeId"
            :displayedBy="'type'"
            :listGetter="resourcefulQuery.fleetType"
            :tableFields="typeTableFields"
            :fullObject="fullObjects['fleetType']"
            @update:formValues="updateFormValues({ key: 'fleetType', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'fleetType', value: $event })"
            :value="formValues.fleetType"
          />
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            name="status"
            label="Status"
            :placeholder="`${$t('global.form.select')} Status`"
            type="select-resourceful-v2"
            :trackBy="'key'"
            :listGetter="resourcefulQuery.statusOptions"
            :fullObject="fullObjects['status']"
            :optionsGetter="resourcefulQuery.statusOptions"
            :optionLabelFn="({ item }) => item.label"
            @update:formValues="updateFormValues({ key: 'status', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'status', value: $event })"
            :value="formValues.status"
          />
        </div>
      </template>
    </McTableFilter>
  </div>
</template>

<script>
import McTableFilter from '@/components/McTableFilter'
import { GET_VEHICLES_PAGINATED } from '@/services/api/master/fleet'
import { GET_VEHICLE_TYPE } from '@/services/api/setting/fleet/fleetType'

export default {
  components: {
    McTableFilter,
  },

  props: {
    activeFilters: {
      required: true,
    },
    handleChangeActiveFilters: {
      type: Function,
    },
    licensePlates: {
      type: Array,
      default: () => [],
    },
    searchWithFilter: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      statusOptions: [
        { key: 'I', label: this.$t('global.active') },
        { key: 'R', label: this.$t('global.repair') },
        { key: 'A', label: this.$t('global.archive') },
      ],
    }
  },

  computed: {
    vehicleTableFields() {
      return [
        {
          label: this.$t('global.object.licensePlate'),
          key: 'licensePlate',
          isSortable: false,
          isRedirectable: true,
        },
        {
          label: this.$t('global.field.vehicleType'),
          key: 'vehicleType',
          formatter(val) {
            const label = [val.category, val.model, val.type]
            return label.filter((x) => x !== null).join('/')
          },
          isSortable: false,
        },
      ]
    },
    typeTableFields() {
      return [
        {
          label: this.$t('global.field.vehicleType'),
          key: 'type',
          isSortable: true,
          isRedirectable: true,
        },
        {
          label: this.$t('global.object.fleetCategory'),
          key: 'category',
          isSortable: true,
          isRedirectable: true,
        },
      ]
    },

    resourcefulQuery() {
      return {
        vehicle: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            orderBy: opts.sorts,
            search: opts.search,
            licensePlates: this.licensePlates,
          }

          const res = await this.$apollo.query({
            query: GET_VEHICLES_PAGINATED,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          const data = res.data.vehiclesPaginated.vehiclesPaginated

          result = {
            metadata: {
              total_count: data.pagination.total,
              page: data.pagination.page,
            },
            data: {
              paginated_result: data.data,
            },
          }

          return result
        },
        fleetType: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_VEHICLE_TYPE,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          const fleetTypeOptions = res.data.vehicleTypes.vehicleTypes

          result = {
            metadata: {
              total_count: fleetTypeOptions.pagination.total,
              page: fleetTypeOptions.pagination.page,
            },
            data: {
              paginated_result: fleetTypeOptions.data,
            },
          }

          return result
        },
        statusOptions: async (opts) => {
          let statusOptions = this.statusOptions
          if (opts.search) {
            statusOptions = statusOptions.filter((item) => this.isContains(opts.search, item.label))
          }
          const result = {
            metadata: {
              total_page: 1,
              total_count: statusOptions.length,
              page: 1,
            },
            data: {
              paginated_result: statusOptions,
            },
          }
          return result
        },
      }
    },

    parseFilterDataMappings() {
      return {
        licensePlate: 'licensePlates',
        fleetType: 'vehicleTypeId',
        status: 'status',
      }
    },
  },

  methods: {
    handleInput(value) {
      this.$emit('handleChangeActiveFilters', value)
    },
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
  },
}
</script>
